import { render, staticRenderFns } from "./choose-eva-category.vue?vue&type=template&id=5830e2c9"
import script from "./choose-eva-category.vue?vue&type=script&lang=js"
export * from "./choose-eva-category.vue?vue&type=script&lang=js"
import style0 from "./choose-eva-category.vue?vue&type=style&index=0&id=5830e2c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports